'use client';

// React 19 removed findDOMNode — polyfill for react-transition-group (via react-select)
import ReactDOM from 'react-dom';
if (typeof window !== 'undefined' && !(ReactDOM as any).findDOMNode) {
  (ReactDOM as any).findDOMNode = (instance: any) => {
    if (instance?.nodeType) return instance;
    // For class components, try to get the underlying DOM node
    return instance?._reactInternals?.stateNode || null;
  };
}

import './globals.css';
import { AuthProvider } from '@/contexts/auth-context';
import { UserContextBridge } from '@/contexts/user-context-bridge';
import { Toaster } from 'react-hot-toast';
import BuildBadge from '@/components/build-badge';

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <html lang="en">
      <head>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link 
          href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap" 
          rel="stylesheet" 
        />
        <title>Stellar</title>
      </head>
      <body className="font-sans antialiased">
        <AuthProvider>
          <UserContextBridge>
            {children}
            <Toaster position="bottom-center" />
            <BuildBadge />
          </UserContextBridge>
        </AuthProvider>
      </body>
    </html>
  );
}
